export default [
    { url: "./models/ifc/wall-1x3.ifc", name: "wall-1x3", width: 1, height: 3, depth: 1 },
    { url: "./models/ifc/wall-with-door-1x3.ifc", name: "wall-with-door-1x3", width: 1, height: 3, depth: 1 },
    { url: "./models/ifc/wall-with-window-1x3.ifc", name: "wall-with-window-1x3", width: 1, height: 3, depth: 1 },
    { url: "./models/ifc/window-1x1.ifc", name: "window-1x1", width: 1, height: 1, depth: 1 },
    { url: "./models/ifc/door-1x2.ifc", name: "door-1x2", width: 1, height: 2, depth: 1 },
    { url: "./models/ifc/door-glass-1x2.ifc", name: "door-glass-1x2", width: 1, height: 2, depth: 1 },
    { url: "./models/ifc/floor-1x1.ifc", name: "floor-1x1", width: 1, height: 1, depth: 1 },
    { url: "./models/ifc/roof-1x1.ifc", name: "roof-1x1", width: 1, height: 1, depth: 1 },
    { url: "./models/ifc/wall-1x1.ifc", name: "wall-1x1", width: 1, height: 1, depth: 1 },
    { url: "./models/ifc/wall-1x1-corner.ifc", name: "wall-1x1-corner", width: 1, height: 1, depth: 1 },
    { url: "./models/ifc/wall-1x1-Wall.ifc", name: "wall-1x1-Wall", width: 1, height: 1, depth: 1 }
]